import { Navigate, Outlet, useLocation } from "react-router-dom"
import { useAuth } from "@pma/stores/auth-store"
import { NEW_DASHBOARD_PAGE_ROUTE } from "@pma/utils/page-routes"
import { ADMIN_ROLE_ID } from "@pma/utils/constants"

const AdminGuard = () => {
  const location = useLocation()
  const { authConfig } = useAuth()

  const organization_id = authConfig?.last_organization_id
  const currentOrgDetails = authConfig?.companies_of_user?.find(
    (org: any) => org.id === organization_id,
  )
  const isAdmin = currentOrgDetails?.role?.id === ADMIN_ROLE_ID

  return isAdmin ? (
    <Outlet />
  ) : (
    <Navigate to={NEW_DASHBOARD_PAGE_ROUTE} state={{ from: location }} replace />
  )
}

export default AdminGuard
